


































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {UsersEntity} from "@/entity/UsersEntity";
import Dates from "@/components/inputs/dates.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";

class coupon {
    code!:string;
    coupon_id!:number;
    created_at!:string;
    end_date!:string;
    min_price!:number;
    percent!:number;
    price!:number;
    start_date!:string;
    updated_at!:string;
    user_id!:number;
    enabled:number = 1;
    single_use:number = 0;
    status:number = 0;
}
@Component({
    components: {
        Decimal,
        EnabledSwitch,
        Dates,
        Select35,
        DeleteButton,EForm,Number,TextField,Id
    }
})
//TODO dates converts datetime
export default class Coupon extends  Vue{
    items : coupon[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "coupon";
    action:string = this.baseAction;
    data : coupon = new coupon();
    users : UsersEntity[] | null = null;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "coupon_id"
        },
        {text: "Kod", value: "code"},
        {text: "Başlangıç tarihi", value: "start_date"},
        {text: "Bitiş tarihi", value: "end_date"},
        {text: "Min sepet tutarı", value: "min_price"},
        {text: "Aktif", value: "enabled"},
        {text: "Durum", value: "status"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:coupon){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.coupon_id;
        this.dialog = true;
    }
    checkStatus(status:number | null){
        if(status == 1){
            return "Kullanılmış";
        }
    }
    tl(){
        if(this.data.price > 0){
            this.data.percent = 0;
        }
    }
    percent(){
        if(this.data.percent > 0){
            this.data.price = 0;
        }
    }
    changeStartTime(value:any){
        this.data.start_date = value;
    }
    changeEndTime(value:any){
        this.data.end_date = value;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new coupon();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    async getUsers(){
        let response = await this.$http.get(ActionsEnum.UsersSanitized);
        this.users = response.data;
    }
    created(){
        this.get();
        this.getUsers();
    }
};
